import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface PageHeaderProps {
  eyebrow?: ReactNode;
  title: ReactNode;
  description?: ReactNode;
  actions?: ReactNode;
  className?: string;
}

export const PageHeader = ({ eyebrow, title, description, actions, className }: PageHeaderProps) => (
  <header className={cn("mb-8 flex flex-col gap-5 sm:flex-row sm:items-end sm:justify-between sm:gap-6", className)}>
    <div className="min-w-0">
      {eyebrow && (
        <div className="mb-2.5 text-[11px] font-semibold uppercase tracking-[0.15em] text-plum">{eyebrow}</div>
      )}
      <h1 className="font-display text-[26px] font-semibold leading-tight tracking-[-0.025em] text-foreground sm:text-[32px]">
        {title}
      </h1>
      {description && <p className="mt-2.5 max-w-[660px] text-[15px] leading-relaxed text-muted-foreground">{description}</p>}
    </div>
    {actions && <div className="flex flex-wrap items-center gap-2.5">{actions}</div>}
  </header>
);

// Shared button looks for page-level actions, matching the reference's primary/secondary buttons
export const primaryButtonClass =
  "inline-flex min-h-[40px] items-center justify-center gap-2 whitespace-nowrap rounded-[9px] bg-gradient-sunset px-[15px] text-[13px] font-semibold text-white shadow-[0_3px_10px_#a23c9112] transition-shadow hover:shadow-[0_4px_14px_#a23c9133] disabled:cursor-not-allowed disabled:opacity-50";

export const secondaryButtonClass =
  "inline-flex min-h-[40px] items-center justify-center gap-2 whitespace-nowrap rounded-[9px] border border-input bg-surface px-[15px] text-[13px] font-semibold text-foreground transition-colors hover:bg-soft disabled:cursor-not-allowed disabled:opacity-50";

export const cardClass = "rounded-[14px] border border-line bg-surface";
